namespace Vit.Administration {
    export interface UserRoleDialogOptions {
        userID: number;
        username: string;
    }

    @Serenity.Decorators.registerClass()
    export class UserRoleDialog extends Serenity.TemplatedDialog<UserRoleDialogOptions> {
        private permissions: RoleCheckEditor;

        constructor(opt: UserRoleDialogOptions) {
            super(opt);

            UserRoleService.List({
                UserID: this.options.userID,
            }, response => {
                this.permissions.value = response.Entities.map(x => x.toString());
            });

            this.permissions = new RoleCheckEditor(this.byId("Roles"));
        }

        protected getTemplate() {
            return '<div id="~_Roles"></div>';
        }

        protected getDialogOptions() {
            let opt = super.getDialogOptions();

            opt.title = Q.format(Q.text("Site.UserRoleDialog.DialogTitle"), this.options.username);
            opt.buttons = [{
                text: Q.text("Dialogs.OkButton"),
                click: () => {
                    UserRoleService.Update({
                        UserID: this.options.userID,
                        Roles: this.permissions.value.map(x => parseInt(x, 10)),
                    }, response => {
                        this.dialogClose();
                        Q.notifySuccess(Q.text("Site.UserRoleDialog.SaveSuccess"));
                    });
                },
            }, {
                text: Q.text("Dialogs.CancelButton"),
                click: () => this.dialogClose(),
            }];

            return opt;
        }
    }
}